import type { PortalEstado, Questionario, TipoDocumento } from '@contefy/shared';

const BASE = import.meta.env.VITE_API_URL ?? '/api';

export interface ErroCampo {
  campo: string;
  mensagem: string;
}

export class ErroApi extends Error {
  constructor(
    mensagem: string,
    readonly status: number,
    readonly erros: ErroCampo[] = [],
  ) {
    super(mensagem);
  }
}

async function chamar<T>(caminho: string, init: RequestInit = {}): Promise<T> {
  const r = await fetch(`${BASE}${caminho}`, {
    ...init,
    headers:
      init.body instanceof FormData
        ? init.headers
        : { 'Content-Type': 'application/json', ...init.headers },
  });
  const texto = await r.text();
  const corpo = texto ? (JSON.parse(texto) as Record<string, unknown>) : {};
  if (!r.ok) {
    const mensagem =
      (corpo.mensagem as string) ?? (corpo.message as string) ?? 'Algo deu errado. Tente de novo.';
    throw new ErroApi(mensagem, r.status, (corpo.erros as ErroCampo[]) ?? []);
  }
  return corpo as T;
}

export const portal = {
  estado: (token: string) => chamar<PortalEstado>(`/portal/${token}`),
  aceitarConsentimento: (token: string) =>
    chamar<PortalEstado>(`/portal/${token}/consentimento`, { method: 'POST' }),
  salvarQuestionario: (token: string, q: Questionario) =>
    chamar<PortalEstado>(`/portal/${token}/questionario`, {
      method: 'PUT',
      body: JSON.stringify(q),
    }),
  enviarDocumento: (token: string, tipo: TipoDocumento, socioId: string | null, arquivo: File) => {
    const form = new FormData();
    form.set('tipo', tipo);
    if (socioId) form.set('socio_id', socioId);
    form.set('arquivo', arquivo, arquivo.name);
    return chamar<{
      estado: PortalEstado;
      documento_id: string;
      status: string;
      motivo: string | null;
      orientacao: string | null;
    }>(`/portal/${token}/documentos`, { method: 'POST', body: form });
  },
  removerDocumento: (token: string, documentoId: string) =>
    chamar<PortalEstado>(`/portal/${token}/documentos/${documentoId}`, { method: 'DELETE' }),
  responder: (token: string, pendenciaId: string, resposta: string) =>
    chamar<PortalEstado>(`/portal/${token}/respostas`, {
      method: 'POST',
      body: JSON.stringify({ pendencia_id: pendenciaId, resposta }),
    }),
};
